import { NgHybridStateDeclaration } from '@uirouter/angular-hybrid';

import { TwoFactorAuthComponent } from './two-factor-auth.component';

export const TwoFactorAuthStates : Array<NgHybridStateDeclaration> = [
  {
    component: TwoFactorAuthComponent,
    name     : 'app.two-factor-auth-login',
    url      : '/two-factor-authentication'
  }
];
